import React, {useState} from 'react'
import "./TypeForm.css"
import {createLead} from "../../services/leads.js"
import { useNavigate } from "react-router-dom";
import BlueButton from '../../components/Buttons/BlueButton/BlueButton';
import GreenProgressBar from '../../components/ProgressBars/GreenProgressBar/GreenProgressBar';


export default function TypeForm(props) {
  const navigate = useNavigate();

  const [formStep, updateFormStep] = useState(1)
  const [buttonNotActive, setButtonActive] = useState(true)
  const [activeBtn, setActiveBtn] = useState("disabled-btn")
  const [progressPercent, setProgressPercent] = useState(25)
  const [lead, setLead] = useState({
    name: "",
    email: "",
    value: "",
    // scheduled:false,
  })

  const handleChange = (e) => {
    setButtonActive(false)
    setActiveBtn("btn-blue")
    const { name, value } = e.target;
    setLead({
      ...lead,
      [name]:value,
    })
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (lead.value !== "") {
      const created = await createLead(lead);
      console.log("created", created)
      if (lead.value === "high") {
        navigate("/schedule-hv")
      } else if (lead.value === "low") {
        navigate("/schedule")
      }
      
    } else {
      alert("Please choose a value!")
   }
    
  }

  const nextStep = () => {
    setButtonActive(true)
    setActiveBtn("disabled-btn")
    updateFormStep(formStep + 1)
    setProgressPercent(progressPercent+25)
  }
  console.log('name', lead.name)
  console.log('email', lead.email)
  console.log('value', lead.value)

  

  return (
    <div className='typeform__container'>
      <div className='progress-bar__holder'>
      <GreenProgressBar progress={progressPercent} />
      </div>
      <div className='typeform__iframe'>
      
        
      {formStep === 1 &&(
        <>
        <div className='step__holder'>
              <h2>1. What is your name?</h2>
              <input
                required
                type="string"
                name="name"
                value={lead.name}
                onChange={handleChange}
                className='typeform__input'
                placeholder="Type your answer here..."
              />
              <BlueButton text="OK" buttonNotActive={buttonNotActive} handleClick={nextStep} activeBtn={activeBtn}  />
        </div>
        </>
        )}

        {formStep === 2 &&(
          <>
          <div className='step__holder'>
              <h2>2. What is your Email?</h2>
              <input
                required
                type="string"
                name="email"
                value={lead.email}
                onChange={handleChange}
                className='typeform__input'
                placeholder="Type your answer here..."
              />
              <BlueButton text="OK" buttonNotActive={buttonNotActive} handleClick={nextStep} activeBtn={activeBtn}  />
        </div>
          </>
        )}
        
        {formStep === 3 &&(
          <>
          <div className='step__holder'>
              <h2>3. High or Low Value Client?</h2>
              <select value={lead.value} className='typeform__input' onChange={handleChange} type="string" required name="value">
              <option value="">-</option>
                <option value="high">High Value Client</option>
                <option value="low">Low Value Client</option>
              </select>
              <BlueButton text="OK" buttonNotActive={buttonNotActive} handleClick={handleSubmit} activeBtn={activeBtn}  />
        </div>
          </>
        )}
        
        <img className="typeform__company-logo" alt="logo" src={props.siteContent[0].company_logo} />
      </div>
    </div>
  )
}
